import { useCallback, useEffect } from "react";

/**
 * Enables capturing Arrow Left/Right keys for pagination navigation
 */
export const usePaginationShortcuts = ({
    onPrevious,
    onNext,
    enabled = true,
}: {
    onPrevious: () => void;
    onNext: () => void;
    enabled?: boolean;
}) => {
    const handleKeyPress = useCallback(
        (event: KeyboardEvent) => {
            if (!enabled) {
                return;
            }

            if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") {
                return;
            }

            const isInputElement =
                event.target instanceof HTMLInputElement ||
                event.target instanceof HTMLTextAreaElement ||
                (event.target instanceof HTMLElement && event.target.isContentEditable);
            if (isInputElement) {
                return;
            }

            if (event.defaultPrevented) {
                return;
            }

            event.preventDefault();

            if (event.key === "ArrowLeft") {
                onPrevious();
            } else {
                onNext();
            }
        },
        [enabled, onPrevious, onNext],
    );

    useEffect(() => {
        document.addEventListener("keydown", handleKeyPress);

        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, [handleKeyPress]);
};
